import { OnboardingData } from 'registration/types';

export const getPhoneText = (phone: OnboardingData['phone']) => {
  if (typeof phone === 'string') {
    return phone as string;
  }

  return phone?.text;
};

export const hasPhone = (phone: OnboardingData['phone']) => {
  if (typeof phone === 'string') {
    return !!phone;
  }

  return !!phone?.text;
};
